import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
// import Routers from './routers';
import App from './App';
import './global.scss';

/**
 * @desc 注入微前端
 */
import './entry/micro';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
